<div class="tiles-track">
  <button type="button" class="add-tile" (click)="selectFile.click()">
    <mat-icon>add</mat-icon>
    <span>{{ 'COMMON.LABEL.ADD' | translate }}</span>
  </button>

  <input
    class="d-none"
    type="file"
    #selectFile
    [attr.multiple]="maxNumberOfFiles > 1 ? '' : null"
    (change)="onFileDropped($event)"
  />

  @for (item of tiles; track $index) {
    @if (item?.id) {
      <ng-container
        *ngTemplateOutlet="imageTileTemplate; context: { $implicit: item, $index: $index }"
      ></ng-container>
    } @else {
      <ng-container
        *ngTemplateOutlet="fileTileTemplate; context: { $implicit: item, $index: $index }"
      ></ng-container>
    }
  }
</div>

<ng-template #imageTileTemplate let-item let-index="$index">
  <div class="image-tile">
    @if (indexFrom !== null && indexFrom !== undefined) {
      <span class="image-index">{{ index + indexFrom }}</span>
    }
    <img [src]="getPresetImageUrl(item)" [alt]="item.name" draggable="false" />
    <button type="button" class="remove-button" (click)="removeTile(index)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #fileTileTemplate let-item let-index="$index">
  <div class="image-tile">
    @if (indexFrom !== null && indexFrom !== undefined) {
      <span class="image-index">{{ index + indexFrom }}</span>
    }
    @if (item.isImage) {
      <img [src]="getImageUrl(item)" [alt]="item.fileObject.name" draggable="false" />
    }
    <button type="button" class="remove-button" (click)="removeTile(index)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</ng-template>
